import { useEffect, useState } from "react";
import { userRequest } from "../../requestMethods";
import { formatTime24hourFormat } from "../../util/helper";
import Loading from "../../components/loading/loading";
import "./monitoring.css";

const CATEGORIES = [
  { key: "produto", label: "Produtos" },
  { key: "pedido", label: "Pedidos" },
  { key: "estoque", label: "Estoque" },
];

const INDICATOR_LABEL = {
  indicator_green: "Ok",
  indicator_yellow: "Atenção",
  indicator_red: "Crítico",
  indicator_gray: "Nunca",
};

const getIndicatorStyle = (indicator) => {
  if (!indicator) return "indicator_gray";
  const val = String(indicator).toLowerCase();
  if (val === "green" || val === "ok") return "indicator_green";
  if (val === "yellow" || val === "warning") return "indicator_yellow";
  return "indicator_red";
};

const allCategoryIndicators = (data) =>
  data.flatMap((item) => CATEGORIES.map((c) => item[c.key]?.indicator));

export default function MonitoringIntegration() {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!search.trim()) {
      setFiltered(data);
    } else {
      const q = search.toLowerCase();
      setFiltered(data.filter((item) => (item.name || "").toLowerCase().includes(q)));
    }
  }, [search, data]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await userRequest.get("standard/checkTudo");
      setData(res.data);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  const indicators = allCategoryIndicators(data);

  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="monitoring_header">
            <div>
              <span className="labelTitle">Monitoramento de Integração</span>
              <br />
              <span className="labelMsgData">
                Status em tempo real das empresas
              </span>
            </div>
            <input
              className="monitoring_search"
              type="text"
              placeholder="Buscar empresa..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="monitoring_summary">
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Empresas</span>
              <span className="monitoring_summary_value">{data.length}</span>
            </div>
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Ok</span>
              <span className="monitoring_summary_value monitoring_value_green">
                {indicators.filter((i) => getIndicatorStyle(i) === "indicator_green").length}
              </span>
            </div>
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Atenção</span>
              <span className="monitoring_summary_value monitoring_value_yellow">
                {indicators.filter((i) => getIndicatorStyle(i) === "indicator_yellow").length}
              </span>
            </div>
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Crítico</span>
              <span className="monitoring_summary_value monitoring_value_red">
                {indicators.filter((i) => getIndicatorStyle(i) === "indicator_red").length}
              </span>
            </div>
          </div>

          <div className="monitoring_grid">
            {filtered.length === 0 && (
              <div className="monitoring_empty">Nenhum registro encontrado.</div>
            )}
            {filtered.map((item) => (
              <div key={item.companyId} className="monitoring_card">
                <div className="monitoring_card_top">
                  <span className="monitoring_company_name">{item.name || "—"}</span>
                  <span className="monitoring_company_id">#{item.companyId}</span>
                </div>
                <div className="monitoring_card_info">
                  {CATEGORIES.map(({ key, label }) => {
                    const cat = item[key] || {};
                    const indicatorClass = getIndicatorStyle(cat.indicator);
                    return (
                      <div key={key} className="monitoring_category_row">
                        <span className="monitoring_category_label">{label}</span>
                        <span className={`monitoring_badge ${indicatorClass}`}>
                          {INDICATOR_LABEL[indicatorClass]}
                        </span>
                        <span className="monitoring_category_date">
                          {cat.createdAt ? (
                            formatTime24hourFormat(cat.createdAt)
                          ) : (
                            <span className="monitoring_null">Nunca</span>
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
